import React from "react";
import PropTypes from "prop-types";
import appPath from "utils/appPath";
import styles from "./styles.module.scss";

const LegalLinks = ({ bloombergSiteUrl, tos = true, privacy = true, help = true }) => {
    return (
        <div className={ styles.legalLinks }>
            { tos && <a href={ `${ bloombergSiteUrl }/notices/tos` } className={ styles.link } target="_blank" rel="noopener">Terms of Service</a> }
            { privacy && <a href={ `${ bloombergSiteUrl }/notices/privacy` } className={ styles.link } target="_blank" rel="noopener">Privacy Policy</a> }
            { help && appPath.isIframePath() && <a href={ `${ bloombergSiteUrl }/notices/help` } className={ styles.link } target="_blank" rel="noopener">Need help?</a> }
        </div>
    );
};

LegalLinks.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired,
    tos: PropTypes.bool,
    privacy: PropTypes.bool,
    help: PropTypes.bool
};

export default LegalLinks;
